/**
 * Режим игры: бета (`mode: "beta"`) — по пути `/beta` (`/ru/beta`, `/uk/beta`) или метке запуска `startapp=beta`;
 * иначе обычная игра. Режим задаётся один раз при старте; транспорт HTTP шлёт его заголовком `X-Game-Mode` в каждом запросе.
 */
import type { GameMode } from "@newfungame/contracts";

export const BETA_START_PARAM = "beta";

/** Режим по пути и метке запуска; иначе `fallback` (режим сервера по умолчанию, стенд беты — `beta`). Чистая функция. */
export function detectMode(pathname: string, startParam: string | null, fallback: GameMode = "main"): GameMode {
  const beta = /^\/(?:(?:ru|uk)\/)?beta\/?$/.test(pathname) || startParam === BETA_START_PARAM;
  return beta ? "beta" : fallback;
}

/** Режим сервера по умолчанию из `GET /config` (`defaultMode`, только на стенде беты). Нет сети или поля — `main`. */
export async function fetchDefaultMode(fetchImpl: typeof fetch = fetch): Promise<GameMode> {
  try {
    const res = await fetchImpl("/config");
    if (!res.ok) return "main";
    const body = (await res.json()) as { defaultMode?: unknown };
    return body.defaultMode === "beta" ? "beta" : "main";
  } catch {
    return "main";
  }
}

let mode: GameMode = "main";

/** Задать режим (при старте, до первого запроса). */
export function setGameMode(next: GameMode): void {
  mode = next;
}

/** Текущий режим игры. */
export function getGameMode(): GameMode {
  return mode;
}
